"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCountryCodeStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const Option_1 = __importDefault(require("../../components/Form/Select/Option"));
exports.useCountryCodeStore = (0, pinia_1.defineStore)('countryCodeStore', {
    state: () => ({
        countryCodes: [],
    }),
    getters: {
        getCountryCodeOptions() {
            let options = [];
            options = this.countryCodes.map((countryCode) => {
                return new Option_1.default(countryCode.countryCode, countryCode.countryName, false);
            });
            return options;
        },
        getCountryZipCodeLength: (state) => (countryCode) => {
            const country = state.countryCodes.find((country) => country.countryCode === countryCode);
            return country ? parseInt(country.zipCodeLength.toString()) : 5;
        },
        getOnlyNumeric: (state) => (countryCode) => {
            const country = state.countryCodes.find((country) => country.countryCode === countryCode);
            return country ? country === null || country === void 0 ? void 0 : country.onlyNumeric : false;
        }
    },
    actions: {
        getCountryCodes(router, params = {}) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'shop_get_country_codes_api', query: params }).href)
                    .then((response) => {
                    let countryCodes = [];
                    if (Array.isArray(response)) {
                        response.forEach(element => {
                            countryCodes.push(element);
                        });
                    }
                    this.countryCodes = countryCodes;
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        }
    },
});
